import { render, staticRenderFns } from "./DesignBaseSlider.vue?vue&type=template&id=d0f5994a&"
import script from "./DesignBaseSlider.vue?vue&type=script&lang=js&"
export * from "./DesignBaseSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports